
export default {
  props: {
    hsrLink: {
      type: Object,
      required: true,
    },
    performanceLink: {
      type: Object,
      required: true,
    },
    equityLink: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.$gsap.set(this.$refs.seals, {
        opacity: 0,
      })

      this.$gsap
        .timeline({ delay: 0.3 })
        .to(this.$refs.rings, {
          rotate: 180,
          duration: 1,
          transformOrigin: 'center',
        })
        .from(
          [this.$refs.outerRing],
          {
            drawSVG: 0,
            duration: 0.8,
            stagger: 0.2,
            delay: 0.1,
          },
          '<=+.1'
        )
        .to(this.$refs.seals, {
          opacity: 1,
          duration: 0.5,
        })
    })
  },
  methods: {
    onClick(linkObj) {
      window.parent.location.href = linkObj.link
    },
  },
}
